//

import { stringToSlug } from './slug';

//function that get section name as string and returns an array of objects with section name and section id
export const getCategoryBasedSectionList = async (
  categoryName: string,
  locale: string
) => {
  //Retrieve product descriptions from Notion DB
  const bodyContent = JSON.stringify({
    property: 'Category',
    select: {
      equals: categoryName
    }
  });

  let productDetailList = [];

  if (process.env.NEXT_PUBLIC_NOTION_PRODUCT_DETAIL_DB) {
    productDetailList = await queryGenericDatabase(
      process.env.NEXT_PUBLIC_NOTION_PRODUCT_DETAIL_DB,
      bodyContent,
      locale
    );
  }


  return productDetailList;
};

export async function queryGenericDatabase(databaseID: string, bodyContent: string, locale: string) {

  // console.log('bodyContent', bodyContent);
  //fetch post request to process.env.NEXT_PUBLIC_LARAVEL_URL + '/api/db/' + databaseID
  const resDBNotion = await fetch(
    process.env.NEXT_PUBLIC_LARAVEL_URL + '/api/db/' + databaseID ,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: bodyContent
    }
  );
  if (resDBNotion.status !== 200) {
    return [];
  }
  const dbDetails = await resDBNotion.json();
  //console.log('dbDetails', dbDetails);
  const productDetailMap: any[] = [];
  if (!dbDetails.error) {
    dbDetails.map((detail: any) => {
      //const sectionSlug = detail.colour;
      //console.log('detail.region', detail.region);
      //console.log('locale', locale);
      if (detail.region.length > 0 && !detail.region.includes(locale)) {
        //console.log('not found');
        return [];
      }
      let sectionSlug = stringToSlug(detail.section);
      if (detail.colour) {
        sectionSlug += '-' + detail.colour;
      }
      const content = {
        slug: sectionSlug,
        sectionTitle: detail.sectionTitle,
        description: detail.description
      };

      productDetailMap.push(content);
    });
  }
  return productDetailMap;
}
